import React from 'react';
import { arrayOf, number, shape } from 'prop-types';

// Utils
import { formatVolume } from 'utils/helpers/format';

// Components
import { useMediaQuery, useTheme } from '@mui/material';
import { Bar, BarChart, CartesianGrid, Cell, Tooltip, XAxis, YAxis } from 'recharts';
import UsageChartTooltip from './UsageChartTooltip';

const UsageChart = props => {
  const { chartHeight, chartWidth, usageData } = props;

  const theme = useTheme();
  const mdUp = useMediaQuery(theme.breakpoints.up(['md']), { noSsr: true });
  return (
    <BarChart
      barSize={mdUp ? 'auto' : 32}
      data={usageData}
      height={chartHeight}
      margin={{
        bottom: 2,
        left: 0,
        top: 16,
      }}
      padding={{ left: 0 }}
      width={chartWidth}
    >
      <XAxis
        axisLine={false}
        dataKey="date"
        interval={0}
        padding={{
          left: mdUp ? 16 : 0,
          right: mdUp ? 16 : 8,
        }}
        // Styles for tick labels
        tick={{
          ...theme.typography.caption,
          // Recharts text element uses 'fill' property
          fill: theme.palette.text.primary,
          fontWeight: 400,
          // Prevents text from not wrapping properly
          width: 66,
        }}
        tickLine={false}
        type="category"
      />
      <YAxis
        axisLine={false}
        margin={{ left: 0 }}
        tickFormatter={tick => {
          return formatVolume(tick);
        }}
        tickLine={false}
      />
      <CartesianGrid strokeDasharray="4" vertical={false} />
      <Tooltip content={<UsageChartTooltip />} />
      {/* Bar comes affter grid otherwise grid will overlay bargraph */}
      <Bar dataKey="volume" radius={[4, 4, 0, 0]}>
        {/* Conditionally colors last bar */}
        {usageData.map((entry, index) => (
          <Cell
            fill={
              index === usageData.length - 1
                ? theme.palette.primary.light
                : theme.palette.primary.main
            }
            key={entry.date}
          />
        ))}
      </Bar>
    </BarChart>
  );
};

UsageChart.propTypes = {
  chartHeight: number,
  chartWidth: number,
  usageData: arrayOf(shape({})).isRequired,
};

UsageChart.defaultProps = {
  chartHeight: 0,
  chartWidth: 0,
};

export default UsageChart;
